import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "common/Context/UserContext";
import AccessDenied from "common/Components/AccessDenied";
import {
  hasDashboardPageAccess,
  redirectToLiveApplication,
  resolveDefaultLandingPath,
  shouldNoneUserUseCustomerAdminLanding,
} from "common/Utilities/EffectiveAccess.utils";
import { isPlatformAdminProfile } from "common/Utilities/Role.utils";
import { resetPlatformAdminCustomerSelection } from "common/Utilities/CustomerSelection.utils";

/**
 * Single app entry at `/`. Resolves the first allowed page from effective access
 * and roles, shows access denied on `/` when nothing applies, or sends
 * app-only users to the external dashboard.
 */
const DefaultLandingRedirect = () => {
  const { userProfile } = useContext(UserContext);
  const profile = userProfile?.profile ?? {};
  const isPlatformAdmin = isPlatformAdminProfile(profile);
  const target = resolveDefaultLandingPath(profile);

  const shouldRedirectToDashboard =
    target === "/access_denied" &&
    hasDashboardPageAccess(profile) &&
    !shouldNoneUserUseCustomerAdminLanding(profile);

  useEffect(() => {
    if (isPlatformAdmin) {
      resetPlatformAdminCustomerSelection();
    }
  }, [isPlatformAdmin]);

  useEffect(() => {
    if (shouldRedirectToDashboard) {
      redirectToLiveApplication();
    }
  }, [shouldRedirectToDashboard]);

  if (shouldRedirectToDashboard) {
    return null;
  }

  if (target === "/access_denied") {
    return <AccessDenied />;
  }

  return <Navigate to={target} replace />;
};

export default DefaultLandingRedirect;
